import {Container, Singleton} from 'typescript-ioc'
import BaseApi from '@/api/BaseApi'
import ThingPropertyMapping from "@/model/ThingPropertyMapping";
import Paging, {PagingQueryForm} from "biz-ts/src/api/Paging";
import ThirdThingProperty from '@/module/thing/ThirdThingProperty';

@Singleton
export default abstract class ThingPropertyMappingApi {
    abstract paging(form: PagingQueryForm): Promise<Paging<ThingPropertyMapping>>

    abstract create(form: TpropMappingCreateForm): Promise<ThingPropertyMapping>

    abstract edit(form: TpropMappingEditForm): Promise<ThingPropertyMapping>

    abstract delete(id: number): Promise<void>
}

class ThingPropertyMappingApiImpl extends BaseApi implements ThingPropertyMappingApi {

    protected urlPrefix = 'thing/property/mapping'

    paging(form: PagingQueryForm): Promise<Paging<ThingPropertyMapping>> {
        return this.axios.post('paging', form)
    }

    create(form: TpropMappingCreateForm): Promise<ThingPropertyMapping> {
        return this.axios.post('create', form)
    }

    edit(form: TpropMappingEditForm): Promise<ThingPropertyMapping> {
        return this.axios.post('edit', form)
    }

    delete(id: number): Promise<void> {
        return this.axios.post('delete', {id: id})
    }
}

Container.bind(ThingPropertyMappingApi).to(ThingPropertyMappingApiImpl)

export class TpropMappingCreateForm {
    categoryId?: number = undefined
    productId?: number = undefined
    identifier?: string = undefined
    tmallProp = new ThirdThingProperty()

    init() {
        this.categoryId = undefined
        this.productId = undefined
        this.identifier = undefined
        this.tmallProp = new ThirdThingProperty()
    }
}

export class TpropMappingEditForm {
    id?: number = undefined
    identifier?: string = undefined
    categoryId?: number = undefined
    productId?: number = undefined
    tmallProp = new ThirdThingProperty()
}
